import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=a932abbe&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a932abbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a932abbe')) {
      api.createRecord('a932abbe', component.options)
    } else {
      api.reload('a932abbe', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=a932abbe&scoped=true&", function () {
      api.rerender('a932abbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hj3VZ7WJflKL/JS/comp/Accordion.vue"
export default component.exports